import {useAuthState} from "react-firebase-hooks/auth";
import { auth } from '../firebase';
import useBoardHook from "./useBoardHook";

const useCheckAdminBoard = (subdomain) => {
    const getDocumentBoard = useBoardHook(subdomain);
    const [user, loading] = useAuthState(auth);

    const admin = (user?.uid && (getDocumentBoard?.data?.admin === user?.uid || getDocumentBoard?.data?.moderator?.includes(user?.uid)));
    return admin;
}

export default useCheckAdminBoard